import { BareFetcher, Key, SWRConfiguration } from 'swr';
import { MutatorCallback, MutatorOptions } from 'swr/_internal';

import { UseSWROutput, useSWR } from '~/hooks/useSWR/useSWR';

export type KeyedArrayMutator<T> = (
  data?: Array<T> | Promise<Array<T>> | MutatorCallback<Array<T>>,
  opts?: boolean | MutatorOptions<Array<T>>,
) => Promise<Array<T>>;

export type UseArraySWROutput<T> = Omit<UseSWROutput<Array<T>>, 'data'> & {
  data: Array<T>;
  mutateArray: KeyedArrayMutator<T>;
};

export const useArraySWR = <T>(
  key: Key,
  fn?: BareFetcher<Array<T>>,
  config?: SWRConfiguration<Array<T>, Error>,
): UseArraySWROutput<T> => {
  const { data, mutate, ...rest } = useSWR<Array<T>>(key, fn, config);

  return {
    data: data ?? [],
    mutate,
    mutateArray: (data, opts) =>
      mutate(data, opts).then((data): T[] => data ?? []),
    ...rest,
  };
};
